// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBoxItem_container__2nQ3F","input-container":"CheckBoxItem_input-container__2L87q"};